export default __webpack_public_path__ + "static/media/puntagalera.6a8289b6.jpg";